import { FractalSDKError, FractalSDKTransactionStatusFetchUnknownError, } from "../../core/error/index.js";
import { useGetTransactionStatusPollerQuery } from "../../queries/transaction.js";
import { TransactionStatus } from "../../types/index.js";
export const useTransactionStatus = (signature) => {
    var _a;
    const { data: responseData, error: errorResponse } = useGetTransactionStatusPollerQuery(signature);
    let status = TransactionStatus.PENDING;
    switch ((_a = responseData === null || responseData === void 0 ? void 0 : responseData.confirmed) === null || _a === void 0 ? void 0 : _a.success) {
        case true:
            status = TransactionStatus.SUCCESS;
            break;
        case false:
            status = TransactionStatus.FAIL;
            break;
    }
    let error;
    if (errorResponse && !(errorResponse instanceof FractalSDKError)) {
        error = new FractalSDKTransactionStatusFetchUnknownError(`Unable to retrieve transaction status. err = ${errorResponse}`);
    }
    return {
        data: status,
        error: error,
    };
};
//# sourceMappingURL=use-transaction-status.js.map